<template>
  <div class="exam-calc">
    <p>Sexo</p>
    <md-radio
      v-model="exam.fields.gender"
      md-value="f"
    >
      Feminino
    </md-radio>
    <md-radio
      v-model="exam.fields.gender"
      md-value="m"
    >
      Masculino
    </md-radio>

    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container :class="{ 'md-input-invalid': exam.rules.age }">
          <label>Idade (anos)</label>
          <md-input
            id="age"
            v-model="exam.fields.age"
            v-validate="'required'"
            v-mask="'###'"
            data-vv-validate-on="none"
            name="age"
            title="Idade (anos)"
            placeholder="Idade (anos)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.age"
            v-mask="'###'"
            type="hidden"
          >
          <span
            v-if="exam.rules.age"
            class="md-error"
          >Digite a partir de 18 anos</span>
        </md-input-container>

        <md-input-container>
          <label>Creatinina (mg/dL)</label>
          <md-input
            id="creatinina"
            v-model="exam.fields.creatinina"
            v-validate="'required'"
            v-mask="creatinine"
            data-vv-validate-on="none"
            name="creatinina"
            title="Creatinina (mg/dL)"
            placeholder="Creatinina (mg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.creatinina"
            v-mask="creatinine"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>
    <div
      v-if="!exam.error"
      class="calc-card__result"
    >
      <template v-if="exam.fields.gender === 'm'">
        <p>
          Homem não negro:
          <strong>
            <span>{{ exam.result.otherCreat }}mL/min/1,73m²</span>
          </strong>
        </p>
        <p>
          Homem negro:
          <strong>
            <span>{{ exam.result.blackCreat }}mL/min/1,73m²</span>
          </strong>
        </p>
      </template>
      <template v-else>
        <p>
          Mulher não negra:
          <strong>
            <span>{{ exam.result.otherCreat }}mL/min/1,73m²</span>
          </strong>
        </p>
        <p>
          Mulher negra:
          <strong>
            <span>{{ exam.result.blackCreat }}mL/min/1,73m²</span>
          </strong>
        </p>
      </template>
    </div>

    <div
      v-else
      class="calc-card__result"
    >
      <p class="alert-error">
        <img
          src="/static/images/icon-alert-solid.svg"
          alt="icone-alerta"
        >
        <span>Todos os campos são obrigatórios</span>
      </p>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcEstimativaFiltracaoGlomerular',
  data: () => {
    return {
      exam: {
        fields: {
          gender: null,
          age: null,
          creatinina: null
        },
        rules: {
          age: false
        },
        error: false,
        result: {
          blackCreat: 0,
          otherCreat: 0
        }
      },
      creatinine: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 2
      })
    }
  },
  methods: {
    calculate() {
      const { gender, age, creatinina } = this.exam.fields;

      if (!gender || !age || !creatinina) {
        this.exam.error = true;
        return;
      }

      this.exam.error = false;

      if (age < 18) {
        this.exam.result.blackCreat = 0;
        this.exam.result.otherCreat = 0;
        this.exam.rules.age = true;
        return;
      }

      this.exam.rules.age = false;

      const parameters = {
        male: { k: 0.9, alfa: -0.302, genderFactor: 1 },
        female: { k: 0.7, alfa: -0.241, genderFactor: 1.012 },
        baseValue: 142,
        exponentAge: 0.9938,
        exponentMax: -1.2
      };

      const config = gender === 'f' ? parameters.female : parameters.male;

      const minValue = Math.min(creatinina / config.k, 1);
      const maxValue = Math.max(creatinina / config.k, 1);

      const result = (
        parameters.baseValue *
        Math.pow(minValue, config.alfa) *
        Math.pow(maxValue, parameters.exponentMax) *
        Math.pow(parameters.exponentAge, age) *
        config.genderFactor
      ).toFixed(2);

      this.exam.result.blackCreat = result;
      this.exam.result.otherCreat = result;
    }
  }
}
</script>